<template>
  <component :is="layouts.current.value">
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </component>
</template>

<script setup lang="ts">
import { useSeedkitLayouts } from 'app/theme/layouts';

const layouts = useSeedkitLayouts();

</script>
